import { Component } from "@angular/core";

@Component({
  selector: 'pg-confirmar-cadastro',
  templateUrl: './confirmar-cadastro.page.html',
  styleUrls: ['./confirmar-cadastro.page.scss']
})
export class ConfirmarCadastroPage {

  constructor(){
  }
}